import { render } from "./MyBooking.vue?vue&type=template&id=fc752ad4&scoped=true"
import script from "./MyBooking.vue?vue&type=script&lang=js"
export * from "./MyBooking.vue?vue&type=script&lang=js"

import "./MyBooking.vue?vue&type=style&index=0&id=fc752ad4&scoped=true&lang=css"

import exportComponent from "E:\\sanket\\rio\\rio_user\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc752ad4"]])

export default __exports__